import * as React from 'react';

import { SignupStep1 } from './step-1';
import { SignupStep2 } from './step-2';
import { SignupStep3 } from './step-3';

interface StepContent {
    component: () => React.JSX.Element;
    label: string;
    role: string;
}

export const stepsContent: StepContent[] = [
    {
        component: SignupStep1,
        label: 'signup.stepper.step1.label',
        role: 'welcome-step'
    },
    {
        component: SignupStep2,
        label: 'signup.stepper.step2.label',
        role: 'data-step'
    },
    {
        component: SignupStep3,
        label: 'signup.stepper.step3.label',
        role: 'summary-step'
    }
];

export const studioLocations = ['DE', 'AT', 'CH', 'FR', 'ES', 'IT', 'UK', 'NL'];
